"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateHash = exports.generateStringHash = void 0;
var get_1 = __importDefault(require("lodash/get"));
var isNil_1 = __importDefault(require("lodash/isNil"));
var INITIAL_VALUE = 17;
var FACTOR = 31;
function generateStringHash(str) {
    if (str.length === 0) {
        return 0;
    }
    var result = INITIAL_VALUE;
    for (var i = 0; i < str.length; i++) {
        result = Math.imul(FACTOR, result) + str.charCodeAt(i);
    }
    return result;
}
exports.generateStringHash = generateStringHash;
function isString(value) {
    return typeof value === 'string' || value instanceof String;
}
function isNumber(value) {
    return typeof value === 'number' && !isNaN(Number(value));
}
function isObject(value) {
    return typeof value === 'object';
}
function generateHash(object, fields, useAllFields) {
    if (useAllFields === void 0) { useAllFields = true; }
    var foundNonNilField = false;
    fields = fields || Object.keys(object);
    var result = fields.reduce(function (acc, field) {
        var objValue = (0, get_1.default)(object, field);
        if (!(0, isNil_1.default)(objValue)) {
            var currentHash = 0;
            if (useAllFields || !foundNonNilField) {
                if (isString(objValue)) {
                    currentHash = generateStringHash(objValue);
                }
                else if (isNumber(objValue)) {
                    currentHash = objValue;
                }
                else if (isObject(objValue)) {
                    currentHash = generateHash(objValue, fields, useAllFields);
                }
            }
            foundNonNilField = true;
            acc = Math.imul(FACTOR, acc) + currentHash;
        }
        return acc;
    }, INITIAL_VALUE);
    if (result !== INITIAL_VALUE) {
        return result;
    }
}
exports.generateHash = generateHash;
//# sourceMappingURL=hash_generator.js.map